import { EcsHeaders, EcsResponseBase } from '@skype/ecsclient/dist/Models';

export class EcsConfig implements EcsResponseBase {
  // ECS Project Team: https://ecs.skype.com/?page=CreateOrEditProjectPage&team=TeamsCustomerEngagementHub&client=MicrosoftTeams
  // ECS Config:
  // https://ecs.skype.com/?page=ExperimentPage&id=42453

  public Headers: EcsHeaders = {
    CountryCode: '',
    ETag: '',
    Expires: '',
    StatusCode: ''
  };

  public ConfigIds: {
    TeamsCustomerEngagementHub: string;
  } = {
    TeamsCustomerEngagementHub: ''
  };

  public TeamsCustomerEngagementHub: {
    EnableEmail: boolean;
    EnableCalling: boolean;
    SetupAutoReply: boolean;
    WatermarkPollingTime: number;
    ExistingGroups: boolean;
    ExistingSharedMailboxes: boolean;
  } = {
    EnableEmail: false,
    EnableCalling: false,
    SetupAutoReply: false,
    WatermarkPollingTime: 10000,
    ExistingGroups: false,
    ExistingSharedMailboxes: false
  };

  public static getDefault = (): EcsConfig => new EcsConfig();
}
